import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6 text-muted"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col mb-12"
}
const _hoisted_3 = { class: "mb-2 text-muted text-danger-dark" }
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "mb-2 text-muted text-danger-dark" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex items-center space-x-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"17px"},
  class: "material-icons"
}, " delete ", -1)
const _hoisted_11 = { class: "flex items-center space-x-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"17px"},
  class: "material-icons"
}, " delete ", -1)
const _hoisted_13 = {
  key: 1,
  class: "relative flex mb-auto card shadow-elevation md:w-9/12 md:ml-16 md:max-h-96 card-filled"
}
const _hoisted_14 = { class: "mb-8 text-lg text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "mt-auto"
}
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col items-center mt-2 mb-auto opacity-70"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "mb-4 opacity-50 material-icons-outlined",
  style: {"font-size":"5rem"}
}, "error_outline", -1)
const _hoisted_18 = { class: "mb-4 select-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TagInput = _resolveComponent("TagInput")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_MinimalExercisePreview = _resolveComponent("MinimalExercisePreview")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showTeacherIntroductionText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_introduction")), 1))
      : _createCommentVNode("", true),
    (_ctx.showTeacherIntroductionText && _ctx.mainStore.tags.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("event_template_rule_editor.no_tags")), 1),
          _createVNode(_component_router_link, {
            class: "mx-auto link",
            to: { name: 'CourseExercises' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Btn, { variant: 'primary-borderless' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("exercise_picker.go_to_exercises")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showTeacherIntroductionText && _ctx.mainStore.tags.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("event_template_rule_editor.no_tags_student")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{
				'opacity-50 cursor-not-allowed pointer-events-none': _ctx.mainStore.tags.length === 0,
			}, "flex flex-col items-start space-y-4 md:flex-row md:space-y-0"])
    }, [
      (_ctx.showTeacherIntroductionText || _ctx.mainStore.tags.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (clause, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'clause-' + clause.id,
                class: "my-2"
              }, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_select_exercises")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_at_least_one")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_among")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_and")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_at_least_one")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_among")), 1)
                    ])),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_TagInput, {
                    placeholder: _ctx.$t('misc.tags'),
                    modelValue: clause.tags,
                    alwaysShowAutocomplete: !_ctx.allowCreateMoreClauses,
                    onAddTag: ($event: any) => (_ctx.onAddTag(clause, $event)),
                    onRemoveTag: ($event: any) => (_ctx.onRemoveTag(clause, $event)),
                    choices: _ctx.mainStore.tags,
                    existingOnly: true,
                    class: "w-full"
                  }, null, 8, ["placeholder", "modelValue", "alwaysShowAutocomplete", "onAddTag", "onRemoveTag", "choices"]),
                  _createVNode(_component_Btn, {
                    tooltip: _ctx.$t('misc.delete'),
                    variant: 'icon',
                    outline: true,
                    onClick: ($event: any) => (_ctx.$emit('deleteClause', clause.id)),
                    class: "transition-opacity duration-100 opacity-50 hover:opacity-100"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["tooltip", "onClick"])
                ])
              ]))
            }), 128)),
            (_ctx.allowCreateMoreClauses)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAddClause && _ctx.onAddClause(...args))),
                  class: "mt-2 transition-opacity duration-75 opacity-50 cursor-pointer hover:opacity-100"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_and")) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_at_least_one")), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_among")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_TagInput, {
                      disabled: true,
                      class: "w-full cursor-pointer",
                      placeholder: _ctx.$t('exercise_editor.exercise_tags'),
                      modelValue: []
                    }, null, 8, ["placeholder"]),
                    _createVNode(_component_Btn, {
                      variant: 'icon',
                      outline: true,
                      class: "invisible"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.localLoading)
              ? (_openBlock(), _createBlock(_component_Spinner, {
                  key: 0,
                  size: 'xl',
                  fast: true,
                  class: "absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col flex-grow", { 'opacity-50 pointer-events-none': _ctx.localLoading }])
            }, [
              _createElementVNode("p", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.eligible_exercises")) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.satisfying.count), 1)
              ]),
              (!!_ctx.satisfying.example)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_15, _toDisplayString(_ctx.$t("misc.example")), 1))
                : _createCommentVNode("", true),
              (!!_ctx.satisfying.example)
                ? (_openBlock(), _createBlock(_component_MinimalExercisePreview, {
                    key: 1,
                    selectable: false,
                    previewable: false,
                    showTags: true,
                    exercise: _ctx.satisfying.example
                  }, null, 8, ["exercise"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("event_template_rule_editor.unsatisfiable_tag_rule")), 1)
                  ]))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}